import React from 'react';
import { useNavigate } from 'react-router';
import styles from 'components/GroupCard.module.css';
import Image from 'components/Image';
import { ImageOwnerType, ImageSize } from 'app-constants';

interface GroupCardProps {
  organization: {
    organizationId: string;
    name: string;
    region: string;
      imageId: string | null;
    memberCount: number;
  };
}

const GroupCard: React.FC<GroupCardProps> = ({ organization }) => {   
    const navigate = useNavigate();
    return (
        <div className={styles.groupCard} onClick={() => navigate(`/groups/${organization.organizationId}`)}>
            <Image imageOwnerType={ImageOwnerType.Organization} imageSize={ImageSize.Card} imageId={organization.imageId} />
            <div>
                <h3>{organization.name}</h3>
                <p>{organization.region}</p>
                <p>{organization.memberCount} Member{organization.memberCount === 1 ? '' : 's'}</p>

            </div>
        </div>
    );
};

export default GroupCard;